import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Tag from "sushiweb/Tag";
import Table from "../../Common/Table";
import * as UserActions from "../../../store/actions/User";
import styled from "styled-components";
import grey from "sushiweb/tokens/color/grey";
import Button from "sushiweb/Button";
import TableFields from "../../../constants/FeatureConfig/ChangeLogTableFields.json";
import * as ConfigChangeLogActions from "../../../store/actions/FeatureConfigDetails";
import ErrorMsgs from "../../../constants/Errors.json";
import { getFormattedFileSize, getPath, getFormattedISODateString } from "../../../utils";
import Modal from "sushiweb/Modal";
import ConfirmationModal from "../../Common/BlackAndWhiteConfirmationModal";
import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";
import black from "sushiweb/tokens/color/black";
import VariantsModal from "../VariantsModal";
import RulesModal from "../RulesModal";
import FeatureConfigFormModal from "../FeatureConfigFormModal";
import * as FeatureConfigActions from "../../../store/actions/FeatureConfig";
import _ from "lodash-es";
import ActionsModal from "../ActionsModal";

const ChangeLogList = (props) => {
  const [modalState, setModalState] = useState(false);
  const [activeLog, setActiveLog] = useState(null);
  const [activeVal, setActiveVal] = useState("");
  const { configVersions, configMetadata, updateChangeLog } = props;

  const handleClick = (type, log) => {
    setActiveLog(log);
    setModalState(type);
  };

  const handleModalClose = () => {
    setActiveLog(null);
    setActiveVal("");
    setModalState(false);
  };

  const viewJsonValue = (val, type) => {
    setActiveVal(val);
    setModalState(type);
  };

  const handleRevert = () => {
    const payload = {
      filters: {
        key: getPath(configMetadata, "key", ""),
        hierarchy: {
          entity: getPath(configMetadata, "entity", ""),
          entityId: getPath(configMetadata, "entityId", ""),
        },
      },
      namespace: getPath(configMetadata, "namespace", ""),
      pagination: {
        limit: 20,
      },
    };
    props
      .filterKeyConfigs(payload)
      .then((res) => {
        // namespace actions required
        let readActionsRequired = _.cloneDeep(getPath(res, "actions.read", []));
        let writeActionsRequired = _.cloneDeep(
          getPath(res, "actions.write", [])
        );

        let keyConfigs = getPath(res, "keyConfigs", []);
        if (keyConfigs.length > 0) {
          // config actions required
          readActionsRequired.push(
            ...getPath(keyConfigs[0], "actions.read", [])
          );
          writeActionsRequired.push(
            ...getPath(keyConfigs[0], "actions.write", [])
          );
        }
        return {
          read: readActionsRequired,
          write: writeActionsRequired,
        };
      })
      .then((actionsRequired) => {
        props
          .updateConfig({
            namespaceConfigs: [
              {
                configs: [
                  {
                    value: getPath(activeLog, "value", ""),
                    key: getPath(configMetadata, "key", ""),
                    entity: getPath(configMetadata, "entity", ""),
                    entityId: getPath(configMetadata, "entityId", ""),
                    variants: getPath(activeLog, "variants", []),
                    rules: getPath(activeLog, "rules", []),
                    actions: getPath(activeLog, "actions", {}),
                    fileSize: getPath(activeLog, "fileSize", 0),
                    stable: getPath(activeLog, "stable", false)
                  },
                ],
                namespace: getPath(configMetadata, "namespace", ""),
              },
            ],
            actionsRequired: actionsRequired,
          })
          .then(() => {
            updateChangeLog();
          });
      })
      .catch((err) => {
        props.setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        });
      });

    handleModalClose();
  };

  const getFieldValue = (log, key, idx) => {
    switch (key) {
      case "value":
        return typeof log[key] === "object" ? (
          <div
            onClick={() =>
              viewJsonValue(getPath(log, key, "null"), "updated_value")
            }
          >
            <JSONInput
              id="jsonInput"
              placeholder={log[key]}
              locale={locale}
              height="100px"
              viewOnly={true}
              colors={{
                string: "#FA7921",
                number: "#50B547",
                background: "#00000000",
                keys: "#1E1E1E",
                default: black,
              }}
              confirmGood={false}
              theme="light_mitsuketa_tribute"
            />
          </div>
        ) : (
          <p style={{ fontSize: "1rem" }} className="medium">
            {String(log[key])}
          </p>
        );
      case "version":
        const value = log[key];
        const clr = grey.z300;
        return (
          <EventTag
            type="tag"
            label={value}
            tagWidth="auto"
            bgColor={clr}
          ></EventTag>
        );
      case "variants":
        return (
          <span
            onClick={() => handleClick("variants", log[key])}
            className="cursor-pointer"
          >
            <p
              style={{
                color: black,
                textDecoration: "underline",
                textDecorationColor: black,
              }}
            >
              {"view"}
            </p>
          </span>
        );
      case "rules":
        return (
          <span
            onClick={() => handleClick("rules", log[key])}
            className="cursor-pointer"
          >
            <p
              style={{
                color: black,
                textDecoration: "underline",
                textDecorationColor: black,
              }}
            >
              {"view"}
            </p>
          </span>
        );
      case "actions":
        return (
          <span
            onClick={() => handleClick("actions", log[key])}
            className="cursor-pointer"
          >
            <p
              style={{
                color: black,
                textDecoration: "underline",
                textDecorationColor: black,
              }}
            >
              {"view"}
            </p>
          </span>
        );
      case "action":
        return idx == 0 ? (
          <Button
            size="small"
            btnColor="coal"
            onClick={() => handleClick("Edit", log)}
          >
            Edit
          </Button>
        ) : (
          <Button
            appearance="outline"
            btnColor="coal"
            size="small"
            onClick={() => handleClick("revert", log)}
          >
            Revert
          </Button>
        );
      case "fileSize":
        return getFormattedFileSize(log[key]);
      case "timestamp": 
        return getFormattedISODateString(log[key])
      case "stable":
        return log[key] ? String(log[key]) : "false";  
      default:
        return getPath(log, key, "NA");
    }
  };

  const getModal = () => {
    switch (modalState) {
      case "variants":
        return (
          <VariantsModal
            handleClose={handleModalClose}
            activeVariants={activeLog}
          ></VariantsModal>
        );
      case "rules":
        return (
          <RulesModal
            handleClose={handleModalClose}
            activeRules={activeLog}
          ></RulesModal>
        );
      case "actions":
        return (
          <ActionsModal
            handleClose={handleModalClose}
            activeActions={activeLog}
          ></ActionsModal>
        );
      case "updated_value":
        return (
          <Modal
            visible={!!modalState}
            onClose={handleModalClose}
            type="large"
            showCloseIcon={true}
            slideOnMobile
            isCentered
            padding="2rem"
            preventFocus
            id="JsonViewModal"
          >
            {typeof activeVal === "object" ? (
              <div>
                <JSONInput
                  id="jsonInput"
                  placeholder={activeVal}
                  locale={locale}
                  height="auto"
                  width="auto"
                  viewOnly={true}
                  colors={{
                    string: "#FA7921",
                    number: "#50B547",
                    background: "#00000000",
                    keys: "#1E1E1E",
                    default: black,
                  }}
                  confirmGood={false}
                  theme="light_mitsuketa_tribute"
                />
              </div>
            ) : (
              <p style={{ fontSize: "1rem" }} className="medium">
                {activeVal}
              </p>
            )}
          </Modal>
        );
      case "Edit":
        return (
          <FeatureConfigFormModal
            modalState={modalState}
            handleClose={handleModalClose}
            selectedNamespace={getPath(configMetadata, "namespace", "")}
            selectedKey={getPath(configMetadata, "key", "")}
            selectedEntity={getPath(configMetadata, "entity", "")}
            selectedEntityId={getPath(configMetadata, "entityId", "")}
            updateChangeLog={updateChangeLog}
            stable={configVersions?.[0].stable}
          ></FeatureConfigFormModal>
        );
      case "revert":
        return (
          <ConfirmationModal
            open={true}
            modalTitle="Revert Config"
            onCofirmCancelHandler={handleModalClose}
            onCofirmSuccessHandler={handleRevert}
            successButtonText="Revert"
            successButtonColor="secondary"
          >
            {`Are you sure to revert config saved under key "${configMetadata.key}" to version "${activeLog.version}"?`}
          </ConfirmationModal>
        );
    }
  };

  return (
    <TableView>
      <Table
        list={configVersions}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
      {!!modalState && getModal()}
    </TableView>
  );
};

const ChangeLogButton = styled(Button)`
  padding: 8px;
  width: 8rem;
  height: 30%;
`;

const EventTag = styled(Tag)`
    margin: 8px,
    height: 30%,
`;

const TableView = styled.section`
  height: fit-content;
  width: fit-content;
  margin: auto;
`;
const mapStateToProps = (state) => {
  const { ConfigChangeLog, CityProperty, GenSetting } = state;
  return {
    GenSettingChangeLog: ConfigChangeLog.GenSettingChangeLog,
    activeCityProperty: CityProperty.activeCityProperty,
    activeGenSetting: GenSetting.activeGenSetting,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getConfigChangeLog: bindActionCreators(
      ConfigChangeLogActions.getConfigChangeLog,
      dispatch
    ),
    updateConfig: bindActionCreators(
      ConfigChangeLogActions.updateConfig,
      dispatch
    ),
    filterKeyConfigs: bindActionCreators(
      FeatureConfigActions.filterKeyConfigs,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeLogList);
